export default __webpack_public_path__ + "locales/ja-JP/PDFFormDialog.json?hash=353dc0b06ce7e186c0f6a8a6b4cba504";